import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // needed for dayClick

import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

import AgendaApi from 'api/agenda';
import AlertHelper from 'helpers/AlertHelper';
import withContentLoader from 'components/ui/withContentLoader';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';

const fetchData = async ({ routeMatch }) => {
  const { params } = routeMatch;
  return await AgendaApi.fetch(params.botId);
};

const AgendaTab = ({ data, botId }) => {
  const { i18n, t } = useTranslation();
  const history = useHistory();

  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('agenda');
    },
  };

  const deleteAllMutation = useMutation(() => AgendaApi.deleteAll(botId), mutationParams);

  const buttonText = {
    today: t('keys.today'),
    month: t('keys.month'),
    week: t('keys.week'),
    day: t('keys.day'),
    list: t('keys.list'),
  };

  const events = data;

  const handleEventClick = async ({ event }) => {
    history.push(`/bots/${botId}/agenda/${event.id}`);
  };

  const handleRemoveAll = async () => {
    const result = await AlertHelper.confirmDanger({
      title: t('agenda.dialogs.remove_all.title'),
      html: t('agenda.dialogs.remove_all.description'),
    });

    if (result.value) {
      await deleteAllMutation.mutate();
    }
  };

  const customButtons = {
    removeall: {
      text: t('actions.remove_all'),
      click: handleRemoveAll,
    },
  };

  const headerToolbar = {
    right: 'today removeall prev,next',
  };

  const lang = i18n.language === 'ptBr' ? 'pt-br' : undefined;

  const renderEventContent = eventInfo => {
    return (
      <>
        <div data-event-id={eventInfo.event.id} className="fc-daygrid-event-dot"></div>
        <div className="fc-event-time">{eventInfo.timeText}</div>
        <div className="fc-event-title">{eventInfo.event.title}</div>
      </>
    );
  };

  return (
    <div className="bg-white shadow p-4">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        eventClick={handleEventClick}
        initialView="dayGridMonth"
        locale={lang}
        buttonText={buttonText}
        events={events}
        eventContent={renderEventContent}
        customButtons={customButtons}
        headerToolbar={headerToolbar}
      />
    </div>
  );
};

const page = withContentLoader(AgendaTab, { name: 'agenda', fetchData });
export default withAuthorizer(page, [Resources.BOT_MANAGER]);
